
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DimssaButton } from "@/components/shared/dimssa-button.vue";
import { sortTags } from "@/helpers/sort-tags";
import { tagUi as buildTagUi, TagUiOptions } from "@/helpers/tag-ui";
import * as Models from "@gigalot/data-models";

type AnimalWithWithdrawal = Models.Animal & { withdrawalDays?: number };

@Component({
  components: {
    DimssaButton,
  },
})
export default class TagList extends Vue {
  @Prop({ default: () => [] }) tags!: Models.Tag[];
  @Prop({ default: () => [] }) animals!: AnimalWithWithdrawal[];
  @Prop({ default: 100 }) pageSize!: number;
  @Prop({ default: () => ({}) }) tagUiOptions!: TagUiOptions;

  tagPageIndex: number = 0;

  get sortedTags(): Models.Tag[] {
    return sortTags([...this.tags], this.animals).reverse();
  }

  get paginatedTags(): Models.Tag[] {
    return this.sortedTags.slice(this.tagPageIndex, this.tagPageIndex + this.pageSize);
  }

  get showingStart(): number {
    if (!this.sortedTags.length) return 0;
    return Math.max(1, this.sortedTags.length - (this.tagPageIndex + this.paginatedTags.length) + 1);
  }

  get showingEnd(): number {
    if (!this.sortedTags.length) return 0;
    return this.sortedTags.length - this.tagPageIndex;
  }

  get canGoPrevious(): boolean {
    return this.tagPageIndex > 0;
  }

  get canGoNext(): boolean {
    return this.tagPageIndex + this.pageSize < this.sortedTags.length;
  }

  goPrevious() {
    if (!this.canGoPrevious) return;
    this.tagPageIndex -= this.pageSize;
    if (this.tagPageIndex < 0) this.tagPageIndex = 0;
  }

  goNext() {
    if (!this.canGoNext) return;
    this.tagPageIndex += this.pageSize;
  }

  tagNumber(index: number): number {
    return this.sortedTags.length - (this.tagPageIndex + index);
  }

  tagUi(tag: Models.Tag): { tag: string; withdrawal?: string } {
    return buildTagUi(tag, this.animals, this.tagUiOptions);
  }

  @Watch("tags")
  onTagsChanged() {
    //this.tagPageIndex = 0;
  }
}
